import React, { createContext, useContext, useState, useEffect } from 'react';
import authService from '../utils/authService';

const AuthContext = createContext({ isLoggedIn: false, isAuthReady: false });

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isAuthReady, setIsAuthReady] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            const params = new URLSearchParams(window.location.search);
            if (params.get('social') === 'success') {
                window.history.replaceState({}, '', window.location.pathname || '/');
            }
            const loggedIn = await authService.isLoggedIn();
            setIsLoggedIn(loggedIn);
            setIsAuthReady(true);
        };

        if (!isAuthReady) {
            checkAuth();
        }
    }, [isAuthReady]);

    return (
        <AuthContext.Provider value={{ isLoggedIn, isAuthReady }}>
            {children}
        </AuthContext.Provider>
    );
};
